var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetnpa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/money_income"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 859",
    x: 3,
    y: 8,
    width: 18,
    height: 14,
    rx: 3,
    stroke: "#17DA64",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 740",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1 0 0 -1 17 20)",
    fill: "#17DA64"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 741",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1 0 0 -1 5 12)",
    fill: "#17DA64"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 742",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 10 17)",
    stroke: "#17DA64",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 3.91421L12.7071 5.20711C12.3166 5.59763 11.6834 5.59763 11.2929 5.20711L10 3.91421M12 2V4.91421",
    stroke: "#17DA64",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetnpa);
export default __webpack_public_path__ + "static/media/netnpa.895e4e9014fcbad7a1f0338a70e892cd.svg";
export { ForwardRef as ReactComponent };